import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';

/**
 * Protected route component
 * @param {Object} props
 * @param {string[]} props.roles - Allowed roles
 * @param {React.ReactNode} props.children - Child components
 */
function ProtectedRoute({ roles, children }) {
  const { session } = useContext(AuthContext);
  const userRoles = session.roles || ['GUEST'];

  const hasAccess = roles.some((role) => userRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;